export const NOTE_TEXT = {
    noteType: {
        english: 'Note type',
        spanish: 'Tipo de nota',
    },
    topic: {
        english: 'Topic',
        spanish: 'Tema',
    },
    subTopic: {
        english: 'Sub topic',
        spanish: 'Subtema',
    },
    dateCreated: {
        english: 'Date created',
        spanish: 'Fecha de creación',
    },
    lastModifiedDate: {
        english: 'Last modified',
        spanish: 'Última creación',
    },
    action: {
        english: 'Action',
        spanish: 'Acción',
    },
    collapseNote: {
        english: 'collapse note',
        spanish: 'colapsar nota',
    },
    expandNote: {
        english: 'expand note',
        spanish: 'ampliar nota',
    },
};
